import type { MatchReactionType } from '@/types';

/** Clé GoPaaS stable pour upsert idempotent (tifosi + match + type). */
export function matchReactionCle(tifosiCle: string, matchCle: string, reaction: MatchReactionType): string {
  return `react-${String(tifosiCle).trim()}-${String(matchCle).trim()}-${reaction}`;
}
